<template>
    <div class="agree_content" v-if="bPointShow">
        <!-- 内容弹窗 -->
        <div class="tips_content" v-if="bContent" @click.stop="bContent = false">
            <div class="tips_warp">
                <div class="tips_warp_title">{{objSmcode.title}}</div>
                <div class="tips_warp_html" v-html="objSmcode.content"></div>
                <div class="btn_refuss" @click.stop="bContent = false">关闭</div>
            </div>
        </div>
        <!-- 允许弹窗 -->
        <div class="agree_tips">
            <div class="text mt">A.O.史密斯艾暖通小程序将为您提供个人定制化服务</div>
            <div class="text mt">可点击<span @click.stop="bContent = true" class="border">A.O.史密斯艾暖通小程序隐私条款</span>查看</div>
            <div class="contsent" @click.stop="bOpenPint = !bOpenPint">
                <div class="no_pint">
                    <div class="open_pint" v-if="bOpenPint"></div>
                </div>
                <div>
                    同意
                    <span>
                        《A.O史密斯艾暖通小程序隐私条款》
                    </span>
                </div>
            </div>
            <div class="btn">
                <div @click.stop="refused">
                    拒绝
                </div>
                <div class="atv" @click.stop="agree">
                允许
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import detail from "@/js/detail.js";
export default {
    name: 'index',
    data(){
        return{
            bOpenPint:true,
            bContent:false,
            bPointShow:false,
            objSmcode:{},
        }
    },
    watch:{
        bPointShow(newDate,oldDate){
            if(newDate){
                let that = this;
                detail.getAgree({ code: "ant_secret_rule"}).then((res) => {
                    that.objSmcode = res.result;
                });
            }
        }
    },
    methods:{
        hide(){
            this.bPointShow = false;
        },
        show(){
            this.bPointShow = true;
        },
        agree(){
            if(!this.bOpenPint){
                this.$toast({
                    message: "请同意协议，即可查看",
                    duration: 1200,
                });
                return false
            }
            detail.getAnalysisPush({type:'ant',element:'ant_secret',action:'click'}).then(res=>{
                this.$emit('resfuss')
                this.bPointShow = false;
            })
        },
        refused(){
            if(Boolean(this.$route.query.goindex)){
                this.$router.go(-1)
            }else{
                this.$toast({
                    message: "请同意协议，即可查看",
                    duration: 1200,
                });
            }
        }
    }
}
</script>

<style lang='scss' scoped>
.tips_content{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 99;
    background: rgba(0, 0, 0, 0.698);
    display: flex;
    align-items: center;
    justify-content: center;
    .tips_warp{
        width: 90%;
        height: 90%;
        background: #fff;
        border-radius: 20px;
        padding: 20px 0;
        box-sizing: border-box;
        .tips_warp_title{
            font-size: 34px;
            line-height: 50px;
            font-weight: 700;
            text-align: center;
        }
        .tips_warp_html{
            margin-top: 20px;
            width: 100%;
            height: calc(100% - 202px);
            overflow-x: hidden;
            overflow-y: scroll;
            padding: 0 20px;
            box-sizing: border-box;
        }
        .btn_refuss{
            width: 318px;
            height: 92px;
            border-radius: 8px;
            border: 2px solid #318544;
            font-size: 28px;
            font-weight: 400;
            line-height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #318544;
            color: #fff;
            margin: 30px auto 0;
        }
    }
}
.agree_content{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 99;
    background: rgba(0, 0, 0, 0.898);
    .agree_tips{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 40px;
        box-sizing: border-box;
        border-radius: 24px 24px 0px 0px;
        background: #fff;
        .text{
            font-size: 28px;
            font-weight: 400;
            color: #313131;
            line-height: 40px;
            text-align: justify;
            span{
                font-size: 28px;
                font-weight: 400;
                color: #318544;
                line-height: 40px;
                margin: 0 10px;
            }
            .border{
                border-bottom: 1px solid #318544;
            }
        }
        .mt{
            margin-top: 14px;
        }
        .contsent{
            display: flex;
            align-items: center;
            margin-top: 60px;
            font-size: 28px;
            font-weight: 400;
            color: #313131;
            line-height: 40px;
            .no_pint{
                width: 40px;
                height: 40px;
                border: 2px solid #318544;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 20px;
                .open_pint{
                    width: 28px;
                    height: 28px;
                    background: #318544;
                    border-radius: 50%;
                }
            }
            span{
                font-size: 28px;
                font-weight: 400;
                color: #318544;
                line-height: 40px;
            }
        }
        .btn{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 40px;
            div{
                width: 318px;
                height: 92px;
                border-radius: 8px;
                border: 2px solid #318544;
                font-size: 28px;
                font-weight: 400;
                color: #318544;
                line-height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            div.atv{
                background: #318544;
                color: #fff;
            }
        }
    }
}
</style>